import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * D2 토큰 이름을 tailwind-merge에 알린다. 모르면 `px-card`와 `px-0`을 다른 무리로 보고 둘 다 남겨,
 * 호출자가 준 `className`이 CSS 순서에 따라 조용히 무시된다(D150).
 */
const twMerge = extendTailwindMerge({
  // Tailwind v4의 text-*는 --tw-leading이 있으면 그것을 쓴다 — 크기가 줄간을 지우지 않게 한다.
  override: { conflictingClassGroups: { 'font-size': [] } },
  extend: {
    theme: {
      spacing: ['tight', 'snug', 'row', 'card', 'pane', 'panel', 'frame'],
      text: ['display'],
      radius: ['card', 'pill'],
      shadow: ['card', 'pop', 'modal', 'sheet'],
      leading: ['ui', 'body', 'read'],
      ease: ['flow', 'drawer'],
      blur: ['scrim'],
      container: ['page-form', 'page-read', 'page-wide'],
    },
  },
});

/** 조건부 클래스 결합 + Tailwind 충돌 해소. 디자인시스템 전 컴포넌트가 이걸 쓴다. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
